import type { DataSourceEntity } from '@unifyapps/defs/types/dataSource';
import { useCallback } from 'react';
import { getIsDataSourceAnEntityType } from '../../../utils/entityDataSource';
import { useDSCDataSourceRecordStore, useDSCEntityTypeDataSources } from '../context/selectors';

export const useGetDataSourceRecord = () => {
  const dataSources = useDSCDataSourceRecordStore().hooks.useDataSources();
  const entityTypeDataSources = useDSCEntityTypeDataSources();

  const getDataSourceRecord = useCallback<(dataSourceId: string) => DataSourceEntity | undefined>(
    (dataSourceId) => {
      if (getIsDataSourceAnEntityType(dataSourceId)) {
        return entityTypeDataSources?.[dataSourceId] as DataSourceEntity | undefined;
      }
      return dataSources?.[dataSourceId];
    },
    [entityTypeDataSources, dataSources],
  );

  return { getDataSourceRecord };
};
